module.exports = __webpack_public_path__ + "img/dashboard_contract_icon.d2e4cc54.svg";